import _ from 'lodash';

export default list => _.zip(_.initial(list), _.tail(list));